exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".uploadBtnCustomStyle[data-v-25e87f11]{background-color:#4466f2;color:#fff}", ""]);

// exports
